"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyLogos = void 0;
const react_1 = __importDefault(require("react"));
const Logo_atom_1 = require("../atoms/Logo.atom");
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = styled_components_1.default.div `
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    align-items: center;
    color: ${(p) => p.theme.palette.text.primary};

    ${(p) => p.theme.breakpoints.down('sm')} {
        margin: 32px 0 0;
        max-width: 100%;
        justify-content: center;
    }
`;
const PropertyLogos = ({ logos = [], locale, epicLogoConfig }) => {
    if (!logos || !logos.length)
        return null;
    return (react_1.default.createElement(Styled, { className: "property-logos" }, logos.map((logo) => {
        if (logo && logo.id) {
            return react_1.default.createElement(Logo_atom_1.Logo, Object.assign({ key: logo.id }, logo, { locale: locale, epicLogoConfig: epicLogoConfig }));
        }
    })));
};
exports.PropertyLogos = PropertyLogos;
//# sourceMappingURL=PropertyLogos.molecule.js.map